import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoService from '../../servicos/DetalhesEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhamentoOrcamentarioInicio: [],
    buscaDetalhamentoOrcamentarioSucesso: ['detalhamentoOrcamentario'],
    buscaDetalhamentoOrcamentarioErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaDetalhamentoOrcamentario = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhamentoOrcamentarioInicio())
        let serv = new DetalhesEmpenhoService()
        return serv
            .consultarDetalhamentoOrcamentario(filtro)
            .then(response => dispatch(Creators.buscaDetalhamentoOrcamentarioSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhamentoOrcamentarioErro(error)))
    }
}

const buscaDetalhamentoOrcamentarioInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhamentoOrcamentarioErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDetalhamentoOrcamentarioSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.detalhamentoOrcamentario, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHAMENTO_ORCAMENTARIO_INICIO]: buscaDetalhamentoOrcamentarioInicio,
    [Types.BUSCA_DETALHAMENTO_ORCAMENTARIO_ERRO]: buscaDetalhamentoOrcamentarioErro,
    [Types.BUSCA_DETALHAMENTO_ORCAMENTARIO_SUCESSO]: buscaDetalhamentoOrcamentarioSucesso,
})
